import { Injectable, inject } from '@angular/core';
import {ModalsFromUrlList, ModalsString} from './modals-from-url-list';
import { first, map, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { TabPanelController, TabsTypes } from '../helpers/tab-panel-controller';
import { UserService } from '../services/user/user.service';
import {AccountPage} from '../../page/account/account.service';
import { RestrictSignupService } from '../services/restrict-signup.service';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalsFromUrlService {
  private _user = inject(UserService);
  private _router = inject(Router);
  private _restrictSignUp = inject(RestrictSignupService);


  /**
   * TabPanelController instance for managing cashier panel
   */
  public controller: TabPanelController = new TabPanelController({
    defaultTab: ModalsFromUrlList.LOGIN,
    availableTabs: ModalsFromUrlList,
    modalsString: ModalsString,
    queryParam: 'modal',
    tabType: TabsTypes.MODAL,
    resolver: this._user.auth$.pipe(
      first(),
      map(auth => !auth),
      switchMap(resolved => this._router.url.includes('modal=registration') ? this._restrictSignUp.isSignUpAvailable$ : of(resolved)),
    ),
    rejectFn: () => this._router.url.includes('modal=registration') && this._restrictSignUp.isSignupRestricted() ? this._router.navigateByUrl('/?modal=login') : !this._router.url.includes('modal') ? this._router.navigateByUrl('/profile/' + AccountPage.DEPOSIT) : null
  });

  /**
   * Available tabs
   */
  get tab() {
    return ModalsFromUrlList;
  }
}
